module.exports = __webpack_public_path__ + "img/bg_login_blue.a8dc6f03.jpg";